import React from 'react';
import { ProductFilterInput } from '../../../../generated/product-service-graphql';
import { useSearchParamHelpers } from '../../_shared/react-hooks';

const AppliedFilters = ({
  filters,
  onClearAllFilters,
  findFilterLabelByValue,
}: {
  filters: ProductFilterInput[];
  onClearAllFilters: () => void;
  findFilterLabelByValue: (value: string) => string;
}) => {
  const { toggleValue } = useSearchParamHelpers(undefined, {
    replace: true,
  });

  return filters.length > 0 ? (
    <ul className="selected-filters d-flex">
      {filters.map((filter) => {
        return filter.values.map((value) => {
          return (
            <li
              className="selected-filter"
              key={`${filter.key}${value}`}
              onClick={() => toggleValue(filter.key, value)}
            >
              <span>{findFilterLabelByValue(value)}</span>
              <span className="alo-cross-primary-icon" style={{ width: '10px', height: '10px' }}></span>
            </li>
          );
        });
      })}
      <li className="clear-all-selected-filters selected-filter" onClick={onClearAllFilters}>
        Clear All
      </li>
    </ul>
  ) : null;
};

export default AppliedFilters;
